import React, { Component } from "react";
import { branch } from "baobab-react/higher-order";

import CountdownTimer from "../timer/CountdownTimer";
//import ModalCountdownPicker from "../components/timer/ModalCountdownPicker";
//import ModalAlarmPicker from "../components/timer/ModalAlarmPicker";

import CountdownTimerTemplates from "../timer/CountdownTimerTemplates";

import * as actionsTimerManager from "../../actions/actionsTimerManager";

let moment = require("moment-timezone");

class Logbook extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalCountdownPickerVisible: false,
			modalAlarmPickerVisible: false
		};

		this._showCountdownPicker = this._showCountdownPicker.bind(this);
		this._hideCountdownPicker = this._hideCountdownPicker.bind(this);
		this._showAlarmPicker = this._showAlarmPicker.bind(this);
		this._hideAlarmPicker = this._hideAlarmPicker.bind(this);
	}

	/*
	shouldComponentUpdate(nextProps, nextState) {
		let should = shallowCompare(this, nextProps, nextState);
		//// console.log("Logbook should: " + should);
		return should;
	}
	*/

	_showCountdownPicker() {
		this.setState({ modalCountdownPickerVisible: true });
	}

	_hideCountdownPicker() {
		this.setState({ modalCountdownPickerVisible: false });
	}

	_showAlarmPicker() {
		this.setState({ modalAlarmPickerVisible: true });
	}

	_hideAlarmPicker() {
		this.setState({ modalAlarmPickerVisible: false });
	}

	render() {
		let timeOut, timeIn, timeOutUtc, timeInUtc;
		// JJB: Not most ideal way to handle this
		try {
			if (this.props.logbook.hasOwnProperty("timeOutLocale") && this.props.logbook.timeOutLocale !== "") {
				let momentTimeOut = moment(this.props.logbook.timeOutLocale);
				timeOutUtc = momentTimeOut.utc().format("YYYY-MM-DD HH:mm") + " UTC";
				timeOut = momentTimeOut.tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm A z") + "\n" + timeOutUtc;
			} else {
				timeOut = "------------";
			}
		} catch (e) {
			timeOut = "------------";
		}
		try {
			if (this.props.logbook.hasOwnProperty("timeInLocale") && this.props.logbook.timeInLocale !== "") {
				let momentTimeIn = moment(this.props.logbook.timeInLocale);
				timeInUtc = momentTimeIn.utc().format("YYYY-MM-DD HH:mm") + " UTC";
				timeIn = momentTimeIn.tz(moment.tz.guess()).format("hh:mm A z") + "\n" + timeInUtc;
			} else {
				timeIn = "------------";
			}
		} catch (e) {
			timeIn = "------------";
		}

		/*
		let addCountdownTimer =
			<Button
				title="Add Timer"
				color="#000088"
				onClick={this._showCountdownPicker} />;

		let addAlarmTimer =
			<Button
				title="Add Alarm"
				color="#000088"
				onClick={this._showAlarmPicker} />;
		*/

		let timersList = this.props.timersList.map(function (timer, i) {
			return (
				<CountdownTimer key={"timer" + i} timerKey={timer} />
			);
		});

		// If already logged elpased time show it, otherwise show running time
		let elapsed;
		try {
			if (this.props.logbook.hasOwnProperty("elapsed")) {
				elapsed = this.props.logbook.elapsed;
			} else {
				elapsed = this.props.flightTimer.elapsed;
			}
		} catch (e) {
			elapsed = this.props.flightTimer.elapsed;
		}

		return (
			<div style={{display: "flex", flexDirection: "column", flex: 1, marginTop: 25, marginBottom: 25, alignItems: "center", width: "100%" }}>				
				<div style={{ fontFamily: "Courier", fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>Current Time (Local)</div>
				<div style={{ paddingBottom: 15, fontFamily: "Courier", fontSize: 16, fontWeight: "normal", color: "#ffffff" }}>{this.props.flightTimer.clock}</div>
				<div style={{ fontFamily: "Courier", fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>Current Time (UTC)</div>
				<div style={{ paddingBottom: 15, fontFamily: "Courier", fontSize: 16, fontWeight: "normal", color: "#ffffff" }}>{this.props.flightTimer.clockUTC}</div>
				<div style={{ fontFamily: "Courier", fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>Time Out</div>
				<div style={{ paddingBottom: 15, fontFamily: "Courier", fontSize: 16, fontWeight: "normal", color: "#ffffff" }}>{timeOut}</div>
				<div style={{ fontFamily: "Courier", fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>Time In</div>
				<div style={{ paddingBottom: 15, fontFamily: "Courier", fontSize: 16, fontWeight: "normal", color: "#ffffff" }}>{timeIn}</div>
				<div style={{ fontFamily: "Courier", fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>Total Time</div>
				<div style={{ paddingBottom: 15, fontFamily: "Courier", fontSize: 16, fontWeight: "normal", color: "#ffffff" }}>{elapsed}</div>
				{this.props.timersList.length > 0 && <div style={{color: "#880000", cursor: "pointer", fontSize: 18}}	onClick={(e) => { this.props.dispatch(actionsTimerManager.deleteAllTimers);}}>Delete All Timers</div>}
				{timersList}
				{/*<div style={{ marginTop: 15, fontWeight: "bold", fontSize: 20, color: "#ffffff" }}>Add Timers</div>
				{addCountdownTimer}
				<div style={{ height: 10 }} />
				{addAlarmTimer}
				<div style={{ height: 10 }} />
				<CountdownTimerTemplates />
				*/}							
				<CountdownTimerTemplates />
			</div>							
		);
	}
}

export default branch({
  logbook: ["activity", "logbook"],
  flightTimer: ["flightTimer"],  
  timersList: ["timersList"]  
}, Logbook);